<template>
  <div class="w-full max-w-5xl mx-auto mt-24">
    <h1 class="text-white text-xl font-semibold mb-3">{{ t.pageTitle }}</h1>

    <section class="w-full rounded-xl border border-[#343743] bg-[#17191f]/95 p-4 shadow-2xl sm:p-6 md:p-8">
      <div class="flex flex-col items-center text-center">
        <div class="flex h-14 w-14 items-center justify-center rounded-full border border-[#FF9B9B] bg-[#FF9B9B]/10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="h-6 w-6 text-[#FF8484]"
          >
            <path d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2Zm1 15h-2v-2h2Zm0-4h-2V7h2Z" />
          </svg>
        </div>

        <h2 class="mt-4 text-4xl text-white md:text-5xl font-bold">{{ t.title }}</h2>
        <p class="mt-3 max-w-3xl text-xl text-gray-400">
          {{ errorMessage || t.subtitle }}
        </p>
      </div>

      <div class="mt-6 space-y-3">
        <button
          type="button"
          @click="$emit('retry')"
          class="w-full rounded-xl bg-[#d0b45e] py-3.5 text-base font-bold text-[#17181d] transition hover:bg-[#dec46e]"
        >
          {{ t.tryAgain }}
        </button>

        <button
          type="button"
          @click="$emit('change-number')"
          class="w-full rounded-xl border border-[#343743] bg-transparent py-3.5 text-base font-bold text-white transition hover:bg-white/5"
        >
          {{ t.changeNumber }}
        </button>
      </div>

      <p class="mt-5 text-center text-sm text-gray-500">{{ t.helpText }}</p>

      <footer class="flex justify-between border-t border-white/10 py-3 mt-6">
        <img src="@/assets/nasna-logo-bok.svg" alt="nasna-logo" class="h-8 w-auto object-cover" />
        <img src="@/assets/bok.png" alt="bok-logo" class="h-8 object-cover" />
      </footer>
    </section>
  </div>
</template>

<script>
import { bokFailureTrs } from "@/bok.trs";

export default {
  emits: ["retry", "change-number"],
  props: {
    currentLanguage: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      default: "",
    },
  },
  computed: {
    t() {
      return bokFailureTrs[this.currentLanguage] || bokFailureTrs.en;
    },
  },
};
</script>
